import React, { useEffect, useState } from "react";
import {
    useLocation
    //, withRouter
} from "react-router-dom";
//import { clearAllBodyScrollLocks } from "body-scroll-lock";
//import styles from "./Main.module.sass";
//import axios from 'axios';
import { useDispatch } from "react-redux";
//import { setEuroValue } from "../../redux/counterSlice";
//import { axiosInstance } from "../../utils/API";
//import { apiCall } from '../../controller/utils'
import Hero from "../../screens/Home/Hero";
import ItemLoreBuilding from "../../screens/ItemLoreBuilding";
import Popular from "../../screens/Home/Popular";
import PastDeals from "../../screens/Home/PastDeals";
import LatestArrivals from '../../screens/Home/LatestArrivals/index';
import ResaleAssets from '../../screens/Home/ResaleAssets/index';
//import RecentSold from '../../screens/Home/RecentSold/index';
import RecentSold from '../../screens/Home/RecentSold';
import AuctionAssets from "../../screens/Home/AuctionAssets";
import Header from "../Header";
import StartInvestingToday from "../../screens/Home/StartInvestingToday";
import WhatIsRealSplit from "../../screens/Home/WhatIsRealSplit";
import SenseiCreateAccount from "../../screens/Home/SenseiCreateAccount";
import SenseiSectionJoinNow from "../../screens/Home/SenseiSectionJoinNow";
import SenseiSectionEquityAndMailboxMoney from "../../screens/Home/SenseiSectionEquityAndMailboxMoney";
//import SectionPropertyInformation from '../../screens/Item/SectionPropertyInformation';
import PropertyInformation from '../../screens/Item/PropertyInformation';
import SearchSection from '../../screens/Search/SearchSection';
import Team from "../../screens/Home/Team";
import Video from "../../screens/Home/Video";
import { NAMES_CONSTANTS } from '../../constants';
//import InvestNowBanner from '../../components/InvestNowBanner';

const Main = (props) => {
//export default const Main = (props) => {

    console.warn('Main()');
    console.warn('Main()', props);

    const { pathname } = useLocation();
    const [productDetails, setProductDetails] = useState(null);
    const [productInfo, setProductInfo] = useState(null);

    useEffect(() => {
        //window.scrollTo(0, 0);
        //clearAllBodyScrollLocks();
        fetchProductDetails(1);
    }, [pathname]);

    //const dispatch = useDispatch();

    /*
    const getpricefeed = async () => {
        const url = process.env.REACT_APP_ADMIN_URL
        await axios
            .get(url + '/admin/exchange/rate')
            .then(res => dispatch(setEuroValue(res.data?.result?.exchangeRate)))
    }

    useEffect(() => {
        getpricefeed();
        dataEncrypt();
        const myInterval = setInterval(() => {
            getpricefeed();
        }, 30000)
        return () => {
            clearInterval(myInterval);
        };
    });

    const dataEncrypt = async () => {
        axiosInstance.get('/user/getClientVariables').then((res) => {
            dispatch(keyDetails(res?.data?.result));
            apiCall()
        });
    };
    */

    const fetchProductDetails = async id => {
        console.debug('screens/Main.fetchProductDetails('+id+')');

        if (id) {

            let fetchConfig = {
                method: 'GET'
                , headers: {
                      //'Accept': 'application/json'
                      'Accept': '*/*'
                    //, 'Content-Type': 'application/json'
                    , Authorization: 'Bearer ' + localStorage.getItem(NAMES_CONSTANTS.USER_ACCESS_TOKEN)
                }
                //, body: JSON.stringify(bodyObject)
            };

            //let fetchPath = `${ process.env.REACT_APP_API_URL }carts/${ assetInfo.id }/listedAssets/${ id }`;
            let fetchPath = `${ process.env.REACT_APP_API_URL }asset/view/${ id }`;
            //let fetchPath = `/asset/view/${ id }`;
            console.debug("fetchPath = ", fetchPath);

            let fetchPromise = fetch(fetchPath, fetchConfig);
            fetchPromise
                .then(function(response) {

                    console.debug("response = ", response);
                    console.debug("response.ok = ", response.ok);
                    console.debug("response.status = ", response.status);
                    console.debug("response.statusText = ", response.statusText);

                    if (response.ok) { // status of 200 signifies sucessful HTTP call, shorthand for checking that status is in the range 200-299 inclusive. Returns a boolean value.

                        //Swal.close();
                        return response.json();

                    } else {

                        response.json().then(function(responseText) {
                            console.debug("responseText = ", responseText);
                            //PopUpWarning(responseText.message, responseText.error, 'warning');
                        });
                    }
                })

                .then(function(responseJson) {
                    console.debug("responseJson = ", responseJson);

                    if (responseJson != null) {

                        /*
                        sendViewProductEvent({
                            addToCard: true,
                            initiateCheckout: true,
                            initiatePurchase: false
                        });
                        
                        let totalItems = responseJson.result.totalItems;
                        console.debug("totalItems = ", totalItems);

                        dispatch(countCart(totalItems));

                        history.push("/cart");
                        */
                        //console.debug('    Item: res?.data?.result = ', res?.data?.result);
                        console.debug('responseJson?.result = ', responseJson?.result);
                        //console.debug('Item: res?.data?.result?.asset = ', res?.data?.result?.asset);

                        setProductDetails(responseJson?.result?.asset);
                        setProductInfo(responseJson?.result);
                        //setProductInfo(responseJson?.data?.result);
                        //res?.data?.result?.asset.auctions?.[0]?.startDate
                        //&& checkForUpcomingBid(res?.data?.result?.asset.auctions?.[0]?.startDate);
                        /*
                        setCategories([
                            {
                                  category: 'black'
                                , content: res?.data?.result?.asset.category?.name
                            }
                        ]);
                        */
                        //setProductPreviews(res?.data?.result?.asset?.files);
                    }
                })

                .catch(error => {
                    console.debug("error = ", error);
                    console.debug("error?.message = ", error?.message);
                    /*
                    console.debug("error?.response = ", error?.response);
                    console.debug("error?.response?.data = ", error?.response?.data);
                    console.debug("error?.response?.data?.message = ", error?.response?.data?.message);
                    let errorMessage = error?.response?.data.message;
                    if (!errorMessage) {
                        errorMessage = error.err || error?.message
                            ? error?.message
                            : error?.data?.response?.message
                    }
                    */

                    //PopUpWarning('Please log in or connect your wallet to add items to your cart.', null, 'error');
                    //PopUpAlert('Alert', errorMessage, 'error');
                    //PopUpAlert('Alert', error?.message, 'error');
                    //PopUpAlert('Alert', error.response?.data?.message, 'error');
                });
        } // if (id)
    }; // fetchProductDetails(id)

    return (
        <>
        <main className = { "home item-main" }>

            {/*
            <InvestNowBanner />
            */}

            {/*
                Header and Hero components in the same section to achieve the effect of having the hero section background image in the header.
            */}
            <section className = { "top-section" }>
                <Header
                    headerClassName = "dark"
                    homePage = "true"
                    //connectWalletFunction       = { props.connectWalletFunction }
                    //clickConnectWalletFunction  = { props.clickConnectWalletFunction }
                    //chooseWalletType            = { props.chooseWalletType }
                    showRegisterDialog          = { props.showRegisterDialog }
                    showLoginDialog             = { props.showLoginDialog }
                    isHomePage                  = { props.isHomePage }
                    userDetails                 = { props.userDetails }
                    loginRegisterFunctions      = { props.loginRegisterFunctions }
                    handleShowMobileNav         = { props.handleShowMobileNav }
                    handleShowMobileUserHeader  = { props.handleShowMobileUserHeader }
                    userProfileMenuRef          = { props.userProfileMenuRef }
                    userProfileButtonRef        = { props.userProfileButtonRef }
                    toggleShowUserProfileMenu   = { props.toggleShowUserProfileMenu }
                    onOutsideClickUserProfileMenu = { props.onOutsideClickUserProfileMenu }

                    /*
                    // Temporarily remove notificationn pending new React Query (post React 19) upgrade.
                    toggleShowNotificationsPopup = { props.toggleShowNotificationsPopup } 
                    handleShowNotificationsPopup = { props.handleShowNotificationsPopup }
                    notificationsButtonRef       = { props.notificationsButtonRef }
                    onClickNotificationsButton   = { props.onClickNotificationsButton }
                    */

                    cartCount = { props.cartCount }
                    //headerComponentRef = { props.headerComponentRef }
                    //ref = { props.headerComponentRef }

                    />

                {/*
                <Hero />
                */}
                <ItemLoreBuilding />
            </section>

            <SenseiCreateAccount
                loginRegisterFunctions = { props.loginRegisterFunctions }
                />

            <SenseiSectionJoinNow
                loginRegisterFunctions = { props.loginRegisterFunctions }
                />

            {/*
            <SearchSection />
            */}
            <SearchSection
                //loginRegisterFunctions = { props.loginRegisterFunctions }
                />

            <SenseiSectionEquityAndMailboxMoney
                loginRegisterFunctions = { props.loginRegisterFunctions }
                />

            <PropertyInformation
                productDetails = { productDetails }
                productInfo = { productInfo }
                showAmenities = { false }
                loginRegisterFunctions = { props.loginRegisterFunctions }
                />

            {/*
            <SenseiSection />
            */}

            <WhatIsRealSplit />

            {/*
            <LatestArrivals
                textColor="#000"
                backgroundImage="linear-gradient(180deg, rgba(212, 222, 236, 0.3) 0%, rgba(217, 217, 217, 0) 100%)"
                />
            */}

            <StartInvestingToday />

            {/*
            <ResaleAssets
                textColor="#000"
                backgroundImage="linear-gradient(180deg, rgba(212, 222, 236, 0.3) 0%, rgba(217, 217, 217, 0) 100%)"
                />
            */}

            {/*
            <RecentSold
                color="#fff"
                textColor="#000"
                />
            */}

            {/*
            */}
            <Video
                //heading = 'HumanPal.io Project #2'
                heading = 'Why Fractional Commercial Real Estate?'
                //heading = 'Why\r\nFractional Commercial\r\nReal Estate?'
                //headingElement = '<div >Why\nFractional Commercial\nReal Estate?'
                //fileName = 'Project_3204_768f0e31-f4e8-4d4c-92e1-2437b855bf48.mp4'
                //filePath = 'https://realsplit.s3.amazonaws.com/properties/Project_3204_768f0e31-f4e8-4d4c-92e1-2437b855bf48.mp4'
                filePath = 'https://realsplit-s3-bucket-us-east-1.s3.amazonaws.com/Project_3204_768f0e31-f4e8-4d4c-92e1-2437b855bf48.mp4'
                styleObject = {{ whiteSpace: 'pre-wrap', color: '#fff' }}
                />

            <Team />

            {/*
            <Video
                //heading = 'HumanPal.io Project #3'
                heading = 'Why RealSplit?'
                //filePath = 'https://realsplit.s3.amazonaws.com/properties/Project_3013_1b6d3535-8329-4c9d-b5d3-0265f45882cc.mp4'
                filePath = 'https://realsplit-s3-bucket-us-east-1.s3.amazonaws.com/Project_3013_1b6d3535-8329-4c9d-b5d3-0265f45882cc.mp4'
                styleObject = {{ whiteSpace: 'pre-wrap', color: '#fff' }}
                />
            */}

            {/*
            <Popular
                textColor="#fff"
                backgroundImage="linear-gradient(180deg, #000000 0%, #2C466B 100%)"
                />
                
            <AuctionAssets
                textColor="#000"
                backgroundImage="linear-gradient(180deg, rgba(212, 222, 236, 0.3) 0%, rgba(217, 217, 217, 0) 100%)"
                />
            */}

            <PastDeals
                textColor="#fff"
                backgroundImage="linear-gradient(180deg, #000000 0%, #2C466B 100%)"
                />

        </main>
        </>
    );
};

//export default withRouter(Main);
export default Main;
